<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="mask0_11652_99214" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
      <rect width="24" height="24" fill="#D9D9D9"/>
    </mask>
    <g mask="url(#mask0_11652_99214)">
      <path d="M6.25 12.75H14.75V11.25H6.25V12.75ZM6.25 9.74998H14.75V8.25003H6.25V9.74998ZM2.5 19.5V4.50003H21.5V19.5H2.5ZM3.99998 18H20V6.00001H3.99998V18Z" fill="currentColor"/>
    </g>
  </svg>
</template>